import API_ENDPOINTS from "../apiEndpoints";
import { axiosInstanceForLambda } from "./Axios";

export const IfscFetch = async (Ifsc) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await axiosInstanceForLambda.get(
        `${API_ENDPOINTS.REACT_APP_IFSC_FETCH}?ifsc=${Ifsc}`
      );
      if (res.data) {
        console.log(res.data);

        if (res.data.branchName.includes('"')) {
          res.data.branchName = res.data.branchName.replace('"', "");
        }
        resolve({
          data: res.data,
          Status: "success",
        });
      } else {
        reject({ Status: "failed" });
      }
    } catch (e) {
      console.log("error", e);
      reject("");
    }
  });
};
